{#if show}
  <nav transition:fly={{x: 300, opacity: 1}}>
	<h2>Patient Forms</h2>
	<p>You can save time at your appointment by downloading, printing and filling out these forms and bringing them in with you. Please also bring your ID and current insurance card.</p>
	<br>
	<h3>Patient Form PDF Download</h3>
	<form method="get" action="/assets/patient_forms.pdf" target="_blank" rel="noopener noreferrer">
		<button class="btn"><i class="fa fa-download"></i> Download</button>
	</form>
	<br><br>
	<button class="btn" on:click={() => {show = false;}}>Close</button>
  </nav>
{/if}

<script>
import { fly } from 'svelte/transition';

export let show = false;
</script>
		
<style>
nav {
  position: fixed;
  top: 25%;
  right: 0;
  max-height: 70%;
  padding: 2rem 1rem 0.6rem;
  border-radius: 15px 0px 0px 15px;
  border-style: solid;
  border-color:rgb(131, 150, 165);
  border-right: none;
  border-width: 2px;
  background: aliceblue;
  overflow-y: auto;
    width: 16rem;
}
.btn {
		background-color: rgb(116, 176, 211);
		border: none;
		color: white;
		padding: 12px 30px;
		cursor: pointer;
		font-size: 20px;
		transition: .1s;
	}

	/* Darker background on mouse-over */
	.btn:hover {
		background-color: rgb(52, 80, 117);
	}
</style>